import * as i0 from '@angular/core';
import { Injectable, Pipe, NgModule } from '@angular/core';
import rg4js from 'raygun4js';

class TranslateService {
    constructor() {
        this.messageformat = new MessageFormat(Translation.language);
    }
    translate(value, args) {
        const data = Translation.data[value] ? Translation.data[value] : value;
        try {
            return this.messageformat.compile(data.replace(/</g, ""))(args);
        }
        catch (e) {
            rg4js("send", {
                error: e,
                customData: {
                    message: `Error in translation: ${data}`,
                    value: value,
                    language: Translation.language,
                },
            });
            return `Error in translation: ${data}`;
        }
    }
}
TranslateService.ɵfac = function TranslateService_Factory(t) { return new (t || TranslateService)(); };
TranslateService.ɵprov = i0.ɵɵdefineInjectable({ token: TranslateService, factory: TranslateService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class TranslatePipe {
    constructor(translations) {
        this.translations = translations;
    }
    transform(value, args) {
        return this.translations.translate(value, args || {});
    }
}
TranslatePipe.ɵfac = function TranslatePipe_Factory(t) { return new (t || TranslatePipe)(i0.ɵɵdirectiveInject(TranslateService)); };
TranslatePipe.ɵpipe = i0.ɵɵdefinePipe({ name: "translate", type: TranslatePipe, pure: true });
TranslatePipe.ɵprov = i0.ɵɵdefineInjectable({ token: TranslatePipe, factory: TranslatePipe.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslatePipe, [{
        type: Injectable
    }, {
        type: Pipe,
        args: [{ name: "translate" }]
    }], function () { return [{ type: TranslateService }]; }, null); })();

class TranslationModule {
}
TranslationModule.ɵfac = function TranslationModule_Factory(t) { return new (t || TranslationModule)(); };
TranslationModule.ɵmod = i0.ɵɵdefineNgModule({ type: TranslationModule });
TranslationModule.ɵinj = i0.ɵɵdefineInjector({ providers: [TranslatePipe, TranslateService] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TranslationModule, { declarations: [TranslatePipe], exports: [TranslatePipe] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationModule, [{
        type: NgModule,
        args: [{
                declarations: [TranslatePipe],
                providers: [TranslatePipe, TranslateService],
                exports: [TranslatePipe],
            }]
    }], null, null); })();

/*
 * Public API Surface of translate
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TranslatePipe, TranslateService, TranslationModule };
//# sourceMappingURL=play-translate.js.map
